export const API_ROUTES = {
  PACKAGES: "/list-packages",
  UPLOAD_IMAGE: "/upload-image/",
  CHECK_KYC: "/check-kyc",
  CREATE_KYC: "/create-kyc",
  PAYMENT_CHANNELS: "list-payment-channels",
  GOOGLE_LOGIN: "/auth/google",
  GOOGLE_CALLBACK: "/auth/callback",
  LAO_QR: "/request-generate-qr",
  LAO_QR_FALLBACK: "/callback-laoqr",
  CREDIT_PAYMENT: "/payment-credit-debit",
  PHONE_NUMBERS: "/list-products",
  ORDER_DETAILS: "/list-order",
  HISTORIES: "/histories",
  ACTIVE_ESIM: "/first-active",
  SMS_EMAIL: "/auth/mail",
  CONFIRM_EMAIL: "/auth/verify-otp",
  GET_CART: "/list-order",
  ADD_TO_CART: "/create-order",
  REMOVE_FROM_CART: "/delete-order",
  CLEAR_CART: "/delete-order-cus",
  INAPP_LOGIN: "/auth/in-app",
  CHECK_PAYMENT_STATUS: "/re-check-payment",
  OCR_PASSPORT_URL: "/ocr-passport",
};

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const socketOptions = {
  // transports: ["websocket"], // skip HTTP long-polling; avoids "Session ID unknown" behind multi-instance/load-balanced backends without sticky sessions
  transports: ["polling"], // skip HTTP long-polling; avoids "Session ID unknown" behind multi-instance/load-balanced backends without sticky sessions
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
};
